import { useActiveUser } from './useActiveUser'
import { RoleValues, UserWithOrganizationResponseDTO } from '../generated/ApiClient'

export const GlobalAdmin: RoleValues[] = ['GlobalAdmin']
export const GlobalEditor: RoleValues[] = ['GlobalAdmin', 'GlobalMember']
export const AllGlobal: RoleValues[] = ['GlobalAdmin', 'GlobalMember', 'RemoteDeviceManufacturing']
export const Admin: RoleValues[] = ['GlobalAdmin', 'OrganizationAdmin']
export const SubGroupViewer = GlobalAdmin.concat(['OrganizationAdmin', 'OrganizationMember'])
/// can edit or view the org email list
export const OrgEmailViewer = GlobalEditor.concat(['OrganizationAdmin'])
export const OrgSiteModemEditor = GlobalEditor.concat(['OrganizationAdmin', 'OrganizationMember'])
export const OrganizationSettableRoles: RoleValues[] = ['OrganizationAdmin', 'OrganizationMember', 'Operator']
/// Roles admins are allowed to change to on User records
export const GlobalSettableRoles = AllGlobal.concat(OrganizationSettableRoles).concat('Default')

export const UserFriendlyRoleNames: { [K in RoleValues]: string } = {
    'GlobalAdmin': 'Global Admin',
    'GlobalMember': 'Global Member',
    'RemoteDeviceManufacturing': 'Remote Device Manufacturing',
    'OrganizationAdmin': 'Organization Admin',
    'OrganizationMember': 'Organization Member',
    'Operator': 'Operator',
    'Default': 'Default'
}

export const RoleFlavourText: { [K in RoleValues]: string } = {
    'GlobalAdmin': 'Global Administrator',
    'GlobalMember': 'Global Custom Experience Team Member',
    'RemoteDeviceManufacturing': 'Remote Device Manufacturing',
    'OrganizationAdmin': 'Administrator within an organization. Members with this role can edit any properties of the organization and create, edit, and delete sites and subgroups within the organization. They can also add and remove members and view email domains available to their organization',
    'OrganizationMember': 'Member within an organization who has access to modems and sites within subgroups. Members with this role can create, edit, and delete sites and communicate with modems within the subgroups they are assigned',
    'Operator': 'Member within an organization who has access to modems and sites within subgroups. Members with this role can only communicate with modems within the subgroups they are assigned',
    'Default': 'No access. Members with this role do not have read/write access to any ClairityLink functionality'
}

export function isInRoles(roles: RoleValues[], role: RoleValues): boolean {
    return roles.includes(role)
}

export function useIsUserInRoles(roles: RoleValues[]): boolean {
    const activeAccountRole = useActiveUser()?.role.Case
    if (activeAccountRole)
        return isInRoles(roles, activeAccountRole)
    else
        return false
}